import {
  Avatar,
  EAvatarSize,
  ETextStyleVariant,
  GeneralIntelligenceIcon,
  Text,
} from '@outdoorsyco/bonfire';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import { IReviewSummaryItem } from '@/services/types/search/rentals/id';
import { getUserInitials } from '@/utility/getUserInitials';

import styles from './AIReviewSummary.module.css';

interface IReviewer {
  firstName: string;
  lastName: string;
  imageUrl: string;
}

interface IAIReviewSummaryProps {
  items: IReviewSummaryItem[];
  reviewers?: IReviewer[];
}

const AIReviewSummary: React.FC<IAIReviewSummaryProps> = ({ items, reviewers = [] }) => {
  if (!items || items.length === 0) {
    return null;
  }

  return (
    <div className={styles.container} data-testid="ai-review-summary">
      <div className={styles.content}>
        <Text className={styles.title} variant={ETextStyleVariant.LargeBold}>
          <FormattedMessage
            id="zhy9qn"
            defaultMessage="Review summary"
            description="AI Review Summary > Title"
          />
        </Text>

        {reviewers.length > 0 && (
          <div className={styles.avatars}>
            {reviewers.slice(0, 3).map((reviewer, index) => (
              <div key={index} className={styles.avatarWrapper} style={{ zIndex: 3 - index }}>
                <Avatar
                  initials={getUserInitials(reviewer.firstName)}
                  imageUrl={reviewer.imageUrl}
                  size={EAvatarSize.Medium}
                  className="overflow-hidden rounded-full"
                />
              </div>
            ))}
          </div>
        )}

        {items.map((item, index) => (
          <div key={index} className={styles.category}>
            <Text className={styles.categoryTitle} variant={ETextStyleVariant.MediumBold}>
              {item.characteristic}
            </Text>
            <Text className={styles.categorySummary} variant={ETextStyleVariant.SmallRegular}>
              {item.clarification}
            </Text>
          </div>
        ))}

        <div className={styles.footer}>
          <GeneralIntelligenceIcon className={styles.icon} />
          <Text className={styles.footerText} variant={ETextStyleVariant.SmallRegular}>
            <FormattedMessage
              id="jDOhJD"
              defaultMessage="AI generated"
              description="AI Review Summary > Footer"
            />
          </Text>
        </div>
      </div>
    </div>
  );
};

export default AIReviewSummary;
